import { Alert, AlertTitle, Typography } from '@mui/material';

import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import { InfoBox } from '@/components/InfoBox';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import { useAppSelector } from '@/hooks/redux-hooks';

import { DataHubCard } from '../../DataHubCard';
import Preview from '../Preview';

export const PreviewCard = () => {
  const { exportSettings } = useExportSettings();
  const { type: exportType } = useAppSelector(state => state.export);
  if (exportSettings.exportType === ExportTypes.IMAGE) {
    return (
      <DataHubCard
        icon={<ChartBoxMultipleOutline sx={{ fontSize: '16px' }} />}
        subtitle='Preview visualization before exporting'
        title='Preview'
      >
        {!exportType ||
          (exportType === ExportTypes.DATA && (
            <InfoBox>
              <Alert
                severity='info'
                sx={{
                  '& .MuiAlert-icon': {
                    color: 'primary.main',
                    paddingTop: 0.5,
                    marginRight: 0.5
                  },
                  backgroundColor: 'inherit',
                  color: 'inherit'
                }}
              >
                <AlertTitle
                  sx={{
                    fontSize: '12px',
                    mb: '8px'
                  }}
                >
                  Image export limited to 6 items.
                </AlertTitle>
                <Typography
                  sx={{
                    fontSize: '12px'
                  }}
                >
                  The last 6 added items will be exported as a spot chart image.
                </Typography>
              </Alert>
            </InfoBox>
          ))}
        <Preview />
      </DataHubCard>
    );
  }
  return null;
};
